module.exports = __webpack_public_path__ + "img/SKMJ_law1.53087a76.jpg";